// extracted by mini-css-extract-plugin
export var container = "index-module--container--TNsDI";
export var item = "index-module--item--c8qH7";
export var list = "index-module--list--uDJHK";
export var paragraph = "index-module--paragraph--d5K67";
export var privacy = "index-module--privacy--oZNwe";